export default {
  edit: {
    visible: 0,
  },
}
